import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-trustpilot-widget',
  standalone: true,
  imports: [],
  templateUrl: './trustpilot-widget.component.html',
  styleUrl: './trustpilot-widget.component.scss',
  host: {
    ngSkipHydration: '', // ✅ aquí sí es válido
  },
})
export class TrustpilotWidgetComponent {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const script = document.createElement('script');
      script.src =
        'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }
}
